import Vue from 'vue';
import Router from 'vue-router';
import Store from './store';
import { MessageBox, Message } from 'element-ui';

import UserInfoService from './request-server/request-services/userinfo-services';

const MainLayout = () => import('./views/main-content-layout/main-layout-component.vue');
const Login = () => import('./views/login/login.vue');
const SysSetting = () => import('./views/main-content-layout/main-content/sys-setting.vue')
const SysAccount = () => import('./views/main-content-layout/main-content/sys-account.vue');
const UnitAccount = () => import('./views/main-content-layout/main-content/unit-account.vue');


const MatchManage = () => import('./views/main-content-layout/main-content/match-manage.vue');
const RefereeManage = () => import('./views/main-content-layout/main-content/referee-manage.vue');
const MatchEdit = () => import('./views/main-content-layout/main-content/match-edit.vue');
const MatchCompetitionPass = () => import('./views/main-content-layout/main-content/match-competition-pass.vue');
const SignUpList = () => import('./views/main-content-layout/main-content/signup-list.vue');
const MatchArrange = () => import('./views/main-content-layout/main-content/match-arrange.vue');
const MatchController = () => import('./views/main-content-layout/main-content/match-controller.vue');
const MatchControllerMerge = () => import('./views/main-content-layout/main-content/match-controller-merge.vue');
const MatchScore = () => import('./views/main-content-layout/main-content/match-score.vue');
const MatchRank = () => import('./views/main-content-layout/main-content/match-rank.vue');
const MatchRefereeScoreView = () => import('./views/main-content-layout/main-content/match-referee-score-view.vue');
const SetOprPwd = () => import('./views/main-content-layout/main-content/sys-setoprpwd.vue');
const MatchScoreView = () => import('./views/main-content-layout/main-content/match-score-view.vue');
const CommonGroupManage = () => import('./views/main-content-layout/main-content/sys-common-group.vue');
const CommonProjectManage = () => import('./views/main-content-layout/main-content/sys-common-project.vue');
const RefereeTypeManage = () => import('./views/main-content-layout/main-content/sys-referee-type-manage.vue');
const MatchTeamScore = () => import('./views/main-content-layout/main-content/match-team-score.vue');
const UnitSignupForm = () => import('./views/main-content-layout/main-content/unit-signup-form.vue');
const SignUpFormPrint = () => import('./views/sign-up-form-print/sign-up-form-print.vue')
//裁判打分模块
const RefereeIndex = () => import('./views/referee-input/index.vue');
const RefereeLogin = () => import('./views/referee-input/referee-login.vue');
const RefereeLayout = () => import('./views/referee-input/referee-layout.vue');
const RefereeInputRecord = () => import('./views/referee-input/referee-content/input-record.vue');

//报名模块页面
const ContestantLayout = () => import('./views/contestant/contestant-layout.vue');
const MatchList = () => import('./views/contestant/contestant-content/match-list.vue');
const PersonalCenter = () => import('./views/contestant/contestant-content/personal-center.vue');
const TeamManage = () => import('./views/contestant/contestant-content/team-manage.vue');
const CompetitionRecord = () => import('./views/contestant/contestant-content/competition-record.vue');
const MatchSignUp = () => import('./views/contestant/contestant-content/match-sign-up.vue');

const ContestantLogin = () => import('./views/contestant/contestant-login.vue');

Vue.use(Router)

const router = new Router({
  routes: [
    {
      //主界面
      path: "/mainpage",
      name: "mainpage",
      component: MainLayout,
      children: [

        {
          path: 'sysetting',
          name: 'sysetting',
          component: SysSetting
        },
        {
          path: 'account-manage',
          component: SysAccount,
          name: '账号管理',
          meta: {
            //roles: ['c6acb217-0534-11ee-835d-7085c23f03b2'],
            title: '账号管理'
          }
        },
        {
          path: 'unit-account',
          component: UnitAccount,
          name: '单位账号',
          meta: {
            //roles: ['c6acb217-0534-11ee-835d-7085c23f03b2'],
            title: '单位账号'
          }
        },
        {
          path: 'unit-signup-form',
          component: UnitSignupForm,
          name: '单位报名表',
          meta: {
            //roles: ['c6acb217-0534-11ee-835d-7085c23f03b2'],
            title: '单位报名表'
          }
        },


        {
          path: 'match-manage',
          component: MatchManage,
          name: '赛事管理',
          meta: {
            //roles: ['c6acb217-0534-11ee-835d-7085c23f03b2'],
            title: '赛事管理'
          }
        },
        {
          path: 'match-edit/:id?',
          component: MatchEdit,
          name: '赛事编辑'
        },
        {
          path: 'match-competition-pass/:id?',
          component: MatchCompetitionPass,
          name: '生成参赛证'
        },
        {
          path: 'referee-manage',
          component: RefereeManage,
          name: '裁判管理'
        },
        {
          path: 'signup-list',
          component: SignUpList,
          name: '报名列表'
        },
        {
          path: 'match-arrange/:id?',
          component: MatchArrange,
          name: '赛事编排'
        },
        {
          path: 'match-controller/:id?',
          component: MatchController,
          name: '赛事调度'
        },
        {
          path: 'match-controller-merge/:id?',
          component: MatchControllerMerge,
          name: '赛事调度合并版'
        },
        {
          path: 'match-score/:id?',
          component: MatchScore,
          name: '赛事成绩'
        },
        {
          path: 'match-team-score/:id?',
          component: MatchTeamScore,
          name: '赛事团队成绩'
        },
        {
          path: 'setoprpwd',
          component: SetOprPwd,
          name: '设置操作密码'
        },
        {
          path: 'common-group',
          component: CommonGroupManage,
          name: '快捷分组管理'
        },
        {
          path: 'common-project',
          component: CommonProjectManage,
          name: '快捷项目管理'
        },
        {
          path: 'referee-type-manage',
          component: RefereeTypeManage,
          name: '裁判类型管理'

        }

      ]
    },

    //登录
    {
      path: "/login",
      name: "login",
      component: Login,
      props: (route) => ({ redirect: route.query["redirect"] })
    },
    {
      path: "/sign-up-form-print/:formId?",
      name: "报名表",
      component: SignUpFormPrint,
    },

    {
      path: "/contestant-login",
      name: "contestant-login",
      component: ContestantLogin,
      props: (route) => ({ redirect: route.query["redirect"] })
    },
    {
      path: "/match-rank/:id?",
      name: "排行榜",
      component: MatchRank,
    },
    {
      path: '/match-score-view/:id?',
      component: MatchScoreView,
      name: '赛事成绩看榜'
    },
    {
      path: '/match-referee-score-view/:mid?/:rid?',
      component: MatchRefereeScoreView,
      name: '评分看板'
    },
    {
      path: "/referee",
      name: "referee",
      component: RefereeIndex,
      children: [
        {
          path: 'login',
          name: 'login',
          component: RefereeLogin,
          props: (route) => ({ redirect: route.query["redirect"] })
        },
        {
          path: '',
          component: RefereeLayout,
          children: [
            {
              path: 'inputrecord',
              name: 'inputrecord',
              component: RefereeInputRecord
            }
          ]
        },
        {
          path: "/",
          redirect: "/referee/inputrecord"
        }
      ]
    },
    {
      path: "/contestant",
      component: ContestantLayout,
      children: [{
        path: 'match-list',
        component: MatchList,
        name: 'match-list',
        meta: {
          title: '赛事列表'
        },

      },
      {
        path: 'personal-center',
        component: PersonalCenter,
        name: 'personal-center',
        meta: {
          title: '个人中心'
        }
      },
      {
        path: 'team-manage',
        component: TeamManage,
        name: 'team-manage',
        meta: {
          title: '团队管理'
        }
      },
      {
        path: 'match-sign-up/:id?',
        component: MatchSignUp,
        name: 'match-sign-up',
        meta: {
          title: '赛事详情'
        }
      },

      {
        path: 'competition-record/:name?',
        component: CompetitionRecord,
        name: 'competition-record',
        meta: {
          title: '参赛记录'
        }
      },
      {
        path: "/",
        redirect: "/contestant/match-list"
      }]
    },
    {
      path: "/",
      redirect: "/contestant"
    }
  ]
});




//全局路由前置守卫
router.beforeEach((to, from, next) => {
  Store.commit("cleanReqCancel");

  // 设置浏览器标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.path.indexOf('login') > -1 || to.path.indexOf('/contestant') > -1 || to.path.indexOf('/referee') > -1) {
    next();
  } else {
    UserInfoService.verifyPermission({
      type: 'Menu',
      value: to.path
    }).then(res => {
      console.log(res);
      if (res.code === 0 && res.data) {
        console.log('通过')
        next();
      } else {
        console.log('不通过')
        MessageBox.alert('您没有权限访问该页面', {
          type: "error"
        });
        //this.Message.error('您没有权限访问该页面');
        next({
          path: '/mainpage',
        });
      }
    });
  }



  //next();
});

export default router;
